import { useState } from 'react'
import { useQuery } from 'react-query'
import { useSelector, shallowEqual } from 'react-redux'
import { ObservationChangeLog } from '../models/client/observation'
import { selectCompanyId } from '../store/company'
import { selectUserToken } from '../store/user'
import { observationClient } from '../clients/ObservationClient'

type Return = {
    data: ObservationChangeLog[]
    isLoading: boolean
    error: Error | null
    page: number
    pageSize: number
    totalPages: number
    totalItems: number
    itemIndex: number
    setPage: (nextIndex: number) => void
}

const PAGE_SIZE = 20

export const useChangeLog = (): Return => {
    const companyId = useSelector(selectCompanyId, shallowEqual)
    const token = useSelector(selectUserToken, shallowEqual)
    const [page, setPage] = useState(0)
    const {
        data: response,
        status,
        error,
    } = useQuery(
        ['changelog', companyId, token, page, PAGE_SIZE],
        () =>
            token && companyId
                ? observationClient.getChangeLog({
                      token,
                      companyId,
                      page,
                      size: PAGE_SIZE,
                  })
                : null,
        {
            enabled: !!token && !!companyId,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )
    const { data, meta } = response || {}
    const total = meta?.total || 0
    const totalPages = Math.ceil(total / PAGE_SIZE)
    const itemIndex = page * PAGE_SIZE
    return {
        error: error instanceof Error ? error : null,
        data: data || [],
        isLoading: status === 'loading',
        totalPages,
        pageSize: PAGE_SIZE,
        totalItems: total,
        itemIndex,
        page,
        setPage: (nextIndex) => {
            setPage(nextIndex)
        },
    }
}
